import { ArrowRight, BriefcaseBusiness, CircleHelp, Hotel, Languages, MapPinned, ShieldAlert, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

const situations = [
  { icon: MapPinned, title: "Moverme por la ciudad", detail: "Taxi, transporte y direcciones" },
  { icon: Hotel, title: "Llegar al alojamiento", detail: "Check-in, reservas y pedidos" },
  { icon: BriefcaseBusiness, title: "Aeropuerto y viaje", detail: "Equipaje, controles y embarque" },
  { icon: ShieldAlert, title: "Necesito ayuda", detail: "Frases claras para una emergencia" },
];

export function AICopilotPage() {
  return (
    <div className="page-stack ai-page">
      <section className="ai-heading">
        <span><Sparkles size={18} /> COPILOTO LINGO</span>
        <h1>Decime qué necesitás resolver</h1>
        <p>Te prepara la frase correcta y abre la traducción con el contexto de la situación.</p>
      </section>
      <Link to="/app/travel" className="ai-prompt-card">
        <div><CircleHelp size={26} /></div>
        <span><small>Probá, por ejemplo</small><strong>“Necesito hacer el check-in del hotel”</strong></span>
        <ArrowRight size={21} />
      </Link>
      <section>
        <div className="section-heading"><div><span className="section-kicker">Accesos rápidos</span><h2>Situaciones frecuentes</h2></div></div>
        <div className="ai-situation-list">
          {situations.map(({ icon: Icon, title, detail }) => (
            <Link to="/app/travel" key={title}><span><Icon size={22} /></span><div><strong>{title}</strong><small>{detail}</small></div><ArrowRight size={18} /></Link>
          ))}
        </div>
      </section>
      <Link to="/app/translate?mode=face" className="ai-translate-cta"><Languages size={23} /><span><strong>Abrir conversación en vivo</strong><small>Manos libres con detección automática</small></span><ArrowRight size={19} /></Link>
      <p className="ai-note"><ShieldAlert size={15} /> En emergencias, la app prioriza frases breves y tono claro. No reemplaza a los servicios de emergencia.</p>
    </div>
  );
}
